import { AxiosError } from "axios";
import { getApi, patchApi, postApi } from "../CreateApi";
import { BodyPost, ResponseGetDaysOfWeek, ResponsePostDayOfWeek } from "./interfaceDaysOfWeek";

export const postDaysOfWeek = async (body: BodyPost): Promise<ResponsePostDayOfWeek> => {
    try {
        const data = await postApi('/day-of-week', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponsePostDayOfWeek;
    }
}

export const getDaysOfWeek = async (year?: string): Promise<ResponseGetDaysOfWeek[]> => {
    try {
        const data = await getApi(`/day-of-week?yearId=${year}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetDaysOfWeek[];
    }
}


export const patchDaysOfWeek = async (body: BodyPost, id?: number): Promise<ResponsePostDayOfWeek> => {
    try {
        const data = await patchApi(`/day-of-week/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponsePostDayOfWeek;
    }
}